import React from 'react'

import './recipe.css'

export interface IDoctorSay {
  backgroundColor: string
  mainText: string
  mainTextColor: string
  subText: string
  subTextColor: string
  doctorImgBGColor: string
  doctorImg: any
}

const DoctorSay = ({
  backgroundColor,
  mainText,
  mainTextColor,
  subText,
  subTextColor,
  doctorImgBGColor,
  doctorImg
}: IDoctorSay) => {
  return (
    <>
      <div className="hidden w-full sm:block" style={{ backgroundColor }}>
        <div className="container mx-auto flex">
          <div className="doctor-say-container mx-auto flex pt-4">
            <div className="flex w-4/6 flex-col justify-center">
              <div className="p-4 pr-10">
                <h2 className="mb-6" style={{ color: mainTextColor }}>
                  {mainText}
                </h2>
                <p style={{ color: subTextColor }}>{subText}</p>
              </div>
            </div>

            <div className="w-2/6">
              <div className="doctor-say-img-wrap relative h-72 w-72 p-4" style={{ backgroundColor: doctorImgBGColor }}>
                <img className="absolute -top-4 left-2 h-full w-full object-cover" src={doctorImg} alt="mainText" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile section */}
      <div className="block w-full p-4 pt-48 sm:hidden" style={{ backgroundColor }}>
        <div className="container relative mx-auto">
          <div
            className="doctor-say-img-wrap-left relative h-52 w-40 p-4"
            style={{ backgroundColor: doctorImgBGColor }}
          >
            <img className="absolute -top-2 -right-1 h-full w-11/12 object-cover" src={doctorImg} alt="mainText" />
          </div>

          <h2 className="mb-4" style={{ color: mainTextColor }}>
            {mainText}
          </h2>
          <p style={{ color: subTextColor }} className="text-sm">
            {subText}
          </p>
        </div>
      </div>
    </>
  )
}

export default DoctorSay

export const DoctorSayProps = {
  name: 'doctorSayProps',
  type: 'object',
  defaultValue: {
    showDoctorSay: true,
    backgroundColor: '#004355',
    mainText: 'Main Description',
    mainTextColor: 'black',
    subText: 'Sub Description',
    subTextColor: 'black',
    doctorImgBGColor: 'pink',
    doctorImg: null
  },
  subFields: [
    { name: 'showDoctorSay', type: 'boolean', defaultValue: true },
    { name: 'backgroundColor', type: 'color', defaultValue: '#004355' },
    { name: 'mainText', type: 'string', defaultValue: 'Main Description' },
    { name: 'mainTextColor', type: 'color', defaultValue: 'black' },
    { name: 'subText', type: 'string', defaultValue: 'Sub Description' },
    { name: 'subTextColor', type: 'color', defaultValue: 'black' },
    { name: 'doctorImg', type: 'file', defaultValue: null },
    { name: 'doctorImgBGColor', type: 'color', defaultValue: 'pink' }
  ]
}
